import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Modulvaljare from './Modulvaljare';
import { TEMA, säkerställFonter, useMobil } from '../theme';
import { Demoskylt, DEMO_HÖJD, useDemo } from '../demo';

const SIDEBAR_BREDD = 260;

function Layout() {
  const location = useLocation();
  const [menyÖppen, setMenyÖppen] = useState(false);
  const ärMobil = useMobil();
  // I demoläget ligger en skylt överst. Meny och innehåll flyttas ner lika mycket.
  const demo = useDemo();
  const överst = demo ? DEMO_HÖJD : 0;

  useEffect(() => {
    säkerställFonter();
  }, []);

  useEffect(() => {
    setMenyÖppen(false);
  }, [location]);

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", minHeight: '100vh', background: TEMA.bg, color: TEMA.ink }}>
      {demo && <Demoskylt kort={ärMobil} />}
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        {!ärMobil && (
          <nav
            style={{
              width: `${SIDEBAR_BREDD}px`,
              flexShrink: 0,
              background: TEMA.bgSidebar,
              borderRight: `1px solid ${TEMA.border}`,
              position: 'fixed',
              top: överst,
              left: 0,
              bottom: 0,
            }}
          >
            <Sidebar />
          </nav>
        )}

        {ärMobil && (
          <div
            style={{
              position: 'fixed',
              top: överst,
              left: 0,
              right: 0,
              // Över den öppna mobilmenyn (100), så att modulväljarens lista
              // syns även när menyn är öppen. Under demoskylten (300).
              zIndex: 150,
              background: TEMA.bgSidebar,
              borderBottom: `1px solid ${TEMA.border}`,
              height: '56px',
              display: 'flex',
              alignItems: 'center',
              padding: '0 20px',
              justifyContent: 'space-between',
            }}
          >
            <Link
              to="/"
              aria-label="Till startsidan"
              onClick={() => setMenyÖppen(false)}
              style={{ fontFamily: "'Fraunces', serif", fontSize: '18px', color: TEMA.ink, textDecoration: 'none' }}
            >
              Vin<em style={{ fontStyle: 'italic', color: TEMA.accent }}>sales</em>
            </Link>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <Modulvaljare variant="sidhuvud" />
            <button
              onClick={() => setMenyÖppen(!menyÖppen)}
              style={{ display: 'flex', flexDirection: 'column', gap: '5px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
              aria-label="Meny"
            >
              <span style={{ display: 'block', width: '22px', height: '2px', background: menyÖppen ? TEMA.accent : TEMA.inkSoft, transition: 'all 0.2s', transform: menyÖppen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
              <span style={{ display: 'block', width: '22px', height: '2px', background: menyÖppen ? 'transparent' : TEMA.inkSoft, transition: 'all 0.2s' }} />
              <span style={{ display: 'block', width: '22px', height: '2px', background: menyÖppen ? TEMA.accent : TEMA.inkSoft, transition: 'all 0.2s', transform: menyÖppen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
            </button>
            </div>
          </div>
        )}

        {ärMobil && menyÖppen && (
          <div
            style={{
              position: 'fixed',
              top: `${56 + överst}px`,
              left: 0,
              right: 0,
              bottom: 0,
              background: TEMA.bgSidebar,
              zIndex: 100,
              overflowY: 'auto',
            }}
          >
            <Sidebar onNavigate={() => setMenyÖppen(false)} />
          </div>
        )}

        <main
          style={{
            flex: 1,
            // Utan minWidth får huvudytan aldrig bli smalare än sitt bredaste
            // innehåll, och ett brett element trycker då ut hela sidan.
            minWidth: 0,
            marginLeft: !ärMobil ? `${SIDEBAR_BREDD}px` : 0,
            marginTop: `${(ärMobil ? 56 : 0) + överst}px`,
            padding: ärMobil ? '22px 16px calc(40px + env(safe-area-inset-bottom))' : '48px 56px',
            boxSizing: 'border-box',
          }}
        >
          <div style={{ maxWidth: '1180px', margin: '0 auto' }}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;